import {
    Component,
    OnInit,
    Output,
    EventEmitter,
    ViewEncapsulation,
    Input,
    OnDestroy,
    AfterViewInit,
    ViewChild,
} from '@angular/core';
import { GeographyService } from './geography.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { get, isEmpty } from 'lodash';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'fw-geography',
    templateUrl: './geography.component.html',
    styleUrls: ['./geography.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class GeographyComponent implements OnInit, OnDestroy, AfterViewInit {
    @Output() geographyEmitter = new EventEmitter<any>();
    @Input() selectedData: any;

    provinces: any[];
    selectedProvince: any;
    filteredProvinces: any[] = [];
    provinceController: FormControl;

    districts: any[];
    selectedDistrict: any;

    towns: any[];
    selectedTown: any;
    filteredTowns: any[] = [];
    townController: FormControl;

    industrialParks: any[];
    selectedIndustryPark: any;
    filteredIndustrialParks: any[] = [];
    industryParkController: FormControl;

    preventDefaultData: boolean;

    private _unsubscribeAll: Subject<any>;

    constructor(private _geographyService: GeographyService) {
        this._unsubscribeAll = new Subject();

        this.preventDefaultData = false;

        this.provinces = [];
        this.districts = [];
        this.towns = [];
        this.industrialParks = [];

        this.selectedProvince = {};
        this.selectedDistrict = {};
        this.selectedTown = {};
        this.selectedIndustryPark = {};

        this.provinceController = new FormControl();
        this.townController = new FormControl();
        this.industryParkController = new FormControl();
    }

    ngOnInit() {
        const setProvince = (provinces) => {
            this.provinces = provinces;
            this.filteredProvinces = [...this.provinces];
            this.towns = [];
            this.industrialParks = [];
            this.selectedTown = {};
            if (this.selectedData && !this.preventDefaultData) {
                this.provinces.forEach((p) => {
                    if (p.id === this.selectedData.provinceId) {
                        this.selectedProvince = p;
                        this.towns = p.towns;
                        this.filteredTowns = [...this.towns];
                        this.industrialParks = p.industrialParks;
                        this.filteredIndustrialParks = [
                            ...this.industrialParks,
                        ];
                        this.provinceController.setValue(this.selectedProvince);
                    }
                });
                this.selectedTown = {
                    id: this.selectedData.townId,
                    name: this.selectedData.town,
                };
                this.townController.setValue(this.selectedTown);

                this.selectedIndustryPark = {
                    id: this.selectedData.industryParkId,
                    name: this.selectedData.industryPark,
                };
                this.industryParkController.setValue(this.selectedIndustryPark);
            }
        };

        if (!isEmpty(this._geographyService.provinces)) {
            setProvince(this._geographyService.provinces);
        } else {
            this._geographyService.getProvinces().then(() => {});
        }

        this._geographyService.onProvincesChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((provinces) => {
                setProvince(provinces);
            });
    }

    filterProvinces(searchText: string) {
        if (!searchText) {
            this.filteredProvinces = [...this.provinces];
            return;
        }
        this.filteredProvinces = this.provinces.filter((province) =>
            province.name.toLowerCase().includes(searchText.toLowerCase())
        );
    }

    filterTowns(searchText: string) {
        if (!searchText) {
            this.filteredTowns = [...this.towns];
            return;
        }
        this.filteredTowns = this.towns.filter((town) =>
            town.name.toLowerCase().includes(searchText.toLowerCase())
        );
    }

    filterIndustrialParks(searchText: string) {
        if (!searchText) {
            this.filteredIndustrialParks = [...this.industrialParks];
            return;
        }
        this.filteredIndustrialParks = this.industrialParks.filter((item) =>
            item.name.toLowerCase().includes(searchText.toLowerCase())
        );
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    ngAfterViewInit(): void {}

    getProvince(e) {
        const value = get(e, 'option.value', null);
        if (isEmpty(value)) return;
        this.preventDefaultData = true;
        this.selectedProvince = value;

        this.towns = value.towns;
        this.filteredTowns = [...this.towns];
        this.selectedTown = {};
        this.townController.setValue(this.selectedTown);

        this.industrialParks = value.industrialParks;
        this.filteredIndustrialParks = [...this.industrialParks];
        this.selectedIndustryPark = {};
        this.industryParkController.setValue(this.selectedIndustryPark);

        this._emitData();
    }

    getTown(e) {
        const value = get(e, 'option.value', null);
        if (isEmpty(value)) return;
        this.preventDefaultData = true;
        this.selectedTown = value;
        this._emitData();
    }

    getIndustrialPark(e) {
        const value = get(e, 'option.value', null);
        if (isEmpty(value)) return;
        this.preventDefaultData = true;
        this.selectedIndustryPark = value;
        this._emitData();
    }

    displayFn(option: any): string {
        return option && option.name ? option.name : '';
    }

    _emitData() {
        this.geographyEmitter.emit({
            province: this.selectedProvince,
            district: this.selectedDistrict,
            town: this.selectedTown,
            industryPark: this.selectedIndustryPark,
        });
    }
}
